import styled, { keyframes } from 'styled-components';
import Color from 'octa-front-sdk/dist/enums/Color';

const Spinner = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const MapLoading = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: #000;
  opacity: 0.4;
  border-radius: 8px;
  z-index: 999;
  display: grid;
  place-items: center;

  svg {
    animation: 1s ${Spinner} infinite ease-in-out;
  }
`;

export const UserLocationBtn = styled.button`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  background-color: ${Color.MeuDeliveryCyan};
  border: none;
  font-weight: normal;
  color: #fff;
  cursor: pointer;
  transition: 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    margin-right: 0.5rem;
  }

  &:hover {
    filter: brightness(0.9);
  }
`;

export const BtnContainer = styled.div`
  width: 100%;
  padding: 1rem 0;
  box-sizing: border-box;

  .next-btn,
  .loading-btn {
    background-color: ${Color.Green500};
  }

  .next-btn:hover {
    filter: brightness(90%);
  }

  .next-btn:disabled {
    background-color: ${Color.Grey400};
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  z-index: 1000;
  margin-bottom: 1rem;
`;

export const MapContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;

  .maps {
    position: relative;
    flex: 1;
  }
`;

export const Container = styled.div`
  padding: 1rem;
  height: 95%;
`;
